import React, {Component} from 'react';
import { getScoreboard } from "../reducers/scoreboard";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import Loading from "./loading";

const CrownIcon = (props) => {
	switch(props.index) {
		case 0:
			return <img width={23} src={require("../img/Leader Scoreboard YELLOW CROWN.svg")} alt=""/>
		case 1:
			return <img width={23} src={require("../img/Leader Scoreboard BLUE CROWN.svg")} alt=""/>
		case 2:
			return <img width={23} src={require("../img/Leader Scoreboard SWORD.svg")} alt=""/>
		default:
			return null
	}
}

class Scoreboard extends Component {
	componentDidMount() {
		this.props.getScoreboard();
	}

	render() {
		let scoreboard = this.props.scoreboard.scoreboard;

		if(!scoreboard.length)
			return <Loading width={270} {...this.props} />

		return (
			<div className="leader__block">
				{scoreboard.map((item, key) => {
					let blockClass = '';

					if(key >= 10)
						return null;

					if(key === 0){
						blockClass = ' yellow black-text'
					}
					else if(key === 1){
						blockClass = ' blue black-text'
					}
					else if(key === 2){
						blockClass = ' gray black-text'
					}

					return (
						<div key={key} className="item">
							<div className="user-name">
								<img src={require("../img/flags/"+item.Country.Code.toLowerCase()+".svg")} alt=""/>

								<p>{item.User}</p>
							</div>
							<div className={"leader__number" + blockClass}>
								<div className="img">
									<CrownIcon index={key} />
								</div>
								<p>{item.Score}</p>
							</div>
						</div>
					)
				})}
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		scoreboard: state.scoreboard
	};
}

const mapDispatchToProps = dispatch => bindActionCreators({
	getScoreboard
}, dispatch)

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Scoreboard);